/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId, { signal } = {}) {
    return axios.get(`${this.url}/${inboxId}/health`, { signal });
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  updateWhatsAppProfile(inboxId, profile) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_profile`, {
      profile,
    });
  }

  getCoexistenceLogs(inboxId, limit = 100) {
    return axios.get(`${this.url}/${inboxId}/coexistence_logs`, {
      params: { limit },
    });
  }

  updateCoexistenceLogs(inboxId, enabled) {
    return axios.patch(`${this.url}/${inboxId}/coexistence_logs`, {
      enabled,
    });
  }

  clearCoexistenceLogs(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/coexistence_logs`);
  }
}

export default new InboxHealthAPI();
